import IndexHeader from 'components/Headers/IndexHeader'
import IndexNavbar from 'components/Navbars/IndexNavbar'
import React from 'react'

const IdolPrankPrivacy = () => {
    React.useEffect(() => {
        document.body.classList.add("index-page");
        document.body.classList.add("sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
        return function cleanup() {
            document.body.classList.remove("index-page");
            document.body.classList.remove("sidebar-collapse");
        };
    });
    return (
        <>
            <IndexNavbar />
            <div className="wrapper">
                <div className="main">
                    <div className="container" style={{ padding: 0 }}>
                        <h2>Terms of Use</h2>
      <p><strong>Our Terms of Use were last updated on Jun 10, 2025.</strong></p>

      {/* 1 */}
      <section>
        <h3>1. Introduction and Acceptance</h3>
        <p>
          These Terms of Use constitute an agreement between
          <strong> BUGUN SOFTWARE COMPANY LIMITED </strong>
          and you, which informs you about your rights and our rights regarding your use of our apps.
        </p>
        <p>
          Please read these terms very carefully, because by using our services, you signify that you
          have read, understood, and agreed to be bound by these terms.
          <strong> If you do not agree to all these terms, you may not use our apps.</strong>
        </p>
      </section>

      {/* 2 */}
      <section>
        <h3>2. Update</h3>
        <p>
          These terms may be updated from time to time. If we make any substantial changes,
          we will notify you, and such changes will take effect upon the update of our terms.
        </p>
        <p>
          Your continued use of our services will be deemed as acceptance of the updated terms.
          We are not obligated to notify you of minor changes.
        </p>
        <p>
          We may automatically update our apps to improve performance, enhance functionality,
          reflect changes in the operating system, or address security concerns.
        </p>
      </section>

      {/* 3 */}
      <section>
        <h3>3. Restrictions</h3>
        <p>
          Users are required to use the app in compliance with all applicable laws, regulations,
          and third-party agreements.
        </p>
        <p>Unless expressly permitted, you must not:</p>

        <ul>
          <li>(a) Copy our apps beyond normal use or backups</li>
          <li>(b) Modify, translate, merge, or combine our apps</li>
          <li>(c) Reverse engineer, decompile, or create derivative works</li>
          <li>(d) Distribute, sell, lease, sublicense, or transfer our apps</li>
          <li>(e) Remove or obscure proprietary notices</li>
          <li>(f) Make our apps available via framing or mirrors</li>
          <li>(g) Extract data or metadata from our apps</li>
          <li><strong>(h) Do anything that may cause damage to our apps</strong></li>
          <li><strong>(i) Carry out harmful or illegal activities</strong></li>
          <li><strong>(j) Use our apps in any manner not authorized</strong></li>
        </ul>

        <p>
          Otherwise, you will compensate us for any losses (including legal fees)
          incurred as a result of the breach.
        </p>
      </section>

      {/* 4 */}
      <section>
        <h3>4. Intellectual Property</h3>
        <p>
          We retain exclusive property rights in our apps, content, and related documentation
          throughout the world.
        </p>
        <p>
          Our apps are protected by copyright, trademark, and other laws.
          Any unauthorized commercial use is not permitted.
        </p>
      </section>

      {/* 5 */}
      <section>
        <h3>5. Links to Third Parties</h3>
        <p>
          Our apps may contain links to third-party websites that are not owned or controlled by us.
        </p>
        <p>
          We are not responsible for the content or your use of such websites.
          You must comply with third-party terms when accessing them.
        </p>
      </section>

      {/* 6 */}
      <section>
        <h3>6. Payment of the Subscription</h3>
        <p>
          Our app may offer subscription plans on a monthly or annual basis.
          Pricing details are provided within the app.
        </p>
        <p>
          Subscriptions automatically renew unless canceled at least 24 hours
          before the end of the current billing period.
        </p>
        <p>
          Subscriptions purchased through Google Play are non-refundable
          for the current billing period.
        </p>
        <p>
          Subscriptions are non-transferable and valid only on Android devices.
        </p>
      </section>

      {/* 7 */}
      <section>
        <h3>7. Termination</h3>
        <p>
          These Terms apply while you use our apps and remain effective until terminated.
        </p>
        <p>
          We may terminate or suspend access immediately if you breach these terms.
          You may terminate by uninstalling the app.
        </p>
      </section>

      {/* 8 */}
      <section>
        <h3>8. Liability</h3>
        <p>
          Our aggregate liability for direct damages is limited to the greater of
          100% of the fees paid by you in the applicable calendar year.
        </p>
        <p>
          OUR APPS ARE FOR DOMESTIC AND PRIVATE USE ONLY.
          WE DISCLAIM LIABILITY FOR COMMERCIAL USE.
        </p>
      </section>

      {/* 9 */}
<section>
  <h3>9. Privacy Policy</h3>
  <p>
    We take the protection of your personal data seriously and are committed to
    handling user data in a transparent and lawful manner in compliance with
    Google Play’s User Data and Privacy requirements.
  </p>

  {/* 9.1 */}
  <h4>9.1 Data We Collect</h4>
  <p>
    Depending on how you use our apps, we may collect the following categories
    of data:
  </p>

  <ul>
    <li>
      <strong>Personal Information:</strong> such as email address or account
      identifiers, if you voluntarily provide them.
    </li>
    <li>
      <strong>Device and Technical Information:</strong> including device model,
      operating system version, language settings, country, and app version.
    </li>
    <li>
      <strong>Usage Data:</strong> such as app interactions, feature usage,
      session duration, crash logs, and performance diagnostics.
    </li>
    <li>
      <strong>Advertising Data:</strong> including advertising identifiers (such
      as Google Advertising ID), used solely for ad delivery, frequency capping,
      attribution, and analytics where applicable.
    </li>
    <li>
      <strong>Subscription and Purchase Data:</strong> confirmation of purchases
      and subscription status (we do not collect or store payment card details).
    </li>
  </ul>

  {/* 9.2 */}
  <h4>9.2 How We Use Your Data</h4>
  <p>
    We use collected data only for legitimate and clearly defined purposes,
    including:
  </p>

  <ul>
    <li>Providing and maintaining app functionality</li>
    <li>Improving performance, stability, and user experience</li>
    <li>Processing subscriptions and restoring purchases</li>
    <li>Displaying and measuring advertisements (where applicable)</li>
    <li>Detecting fraud, abuse, or technical issues</li>
    <li>Complying with legal obligations</li>
  </ul>

  <p>
    We do not use personal data for purposes unrelated to the app’s core
    functionality without your explicit consent.
  </p>

  {/* 9.3 */}
  <h4>9.3 Data Sharing and Third Parties</h4>
  <p>
    We may share limited user data with trusted third-party service providers
    strictly for app-related purposes, such as:
  </p>

  <ul>
    <li>Analytics services (e.g., app performance and usage measurement)</li>
    <li>Advertising partners (for ad delivery and attribution)</li>
    <li>Cloud infrastructure and data storage providers</li>
  </ul>

  <p>
    All third parties are contractually required to process data in compliance
    with applicable data protection laws and Google Play policies.
  </p>
  <p><strong>We do not sell user data to third parties.</strong></p>

  {/* 9.4 */}
  <h4>9.4 Data Retention and Security</h4>
  <p>
    We retain user data only for as long as necessary to fulfill the purposes
    described in this Privacy Policy, unless a longer retention period is
    required by law.
  </p>
  <p>
    We implement appropriate technical and organizational measures to protect
    user data against unauthorized access, loss, misuse, or alteration.
  </p>

  {/* 9.5 */}
  <h4>9.5 User Rights and Choices</h4>
  <p>
    Depending on your jurisdiction, you may have the right to:
  </p>

  <ul>
    <li>Access, update, or delete your personal data</li>
    <li>Withdraw consent where consent was previously given</li>
    <li>Opt out of personalized advertising through your device settings</li>
    <li>Request information about how your data is processed</li>
  </ul>

  <p>
    You may exercise these rights by contacting us using the details provided
    below.
  </p>

  {/* 9.6 */}
  <h4>9.6 Children’s Privacy</h4>
  <p>
    Our apps are not knowingly designed to collect personal data from children
    under the age required by applicable laws without parental consent.
  </p>
  <p>
    If we become aware that such data has been collected unintentionally, we
    will take steps to delete it promptly.
  </p>

  {/* 9.7 */}
  <h4>9.7 Changes to This Privacy Policy</h4>
  <p>
    We may update this Privacy Policy from time to time to reflect changes in
    legal requirements, app functionality, or data practices.
  </p>
  <p>
    Material changes will be communicated through the app or other appropriate
    means. Continued use of the app constitutes acceptance of the updated
    Privacy Policy.
  </p>

  {/* 9.8 */}
  <h4>9.8 Contact Information</h4>
  <p>
    If you have any questions, requests, or concerns regarding this Privacy
    Policy or our data practices, you may contact us.
  </p>
</section>


      {/* 10 */}
      <section>
        <h3>10. Disclaimers and Warranties</h3>
        <p>
          The services and software are provided “AS IS” and “AS AVAILABLE”
          without warranties of any kind.
        </p>

        <ul>
          <li>(A) The service may not be uninterrupted or error-free</li>
          <li>(B) Results may not be accurate or reliable</li>
          <li>(C) The service may not meet expectations</li>
          <li>(D) Defects may not be corrected</li>
          <li>(E) The service may contain harmful components</li>
        </ul>

        <p>You assume full responsibility for your use of the services.</p>
      </section>

      {/* 11 */}
      <section>
        <h3>11. Governing Law and Jurisdiction</h3>
        <p>
          These Terms are governed by the laws of the State of California, USA.
          Disputes shall be resolved in the courts of California.
        </p>
      </section>

      {/* 12 */}
      <section>
        <h3>12. General</h3>
        <p>
          If any provision is deemed invalid, the remaining provisions remain effective.
        </p>
        <p>
          Disputes shall be settled amicably or through courts of competent jurisdiction.
        </p>
        <p>
          If you have questions or feedback, please contact us.
        </p>
      </section>

                    </div>
                </div>
            </div>
        </>
    )
}

export default IdolPrankPrivacy